The value of `AdvertisementBranding.id` for the requested object.
